<template>
  <div
    class="row-span-2 box-border grid grid-rows-subgrid gap-2 border-b border-[#D9D9D9] py-[21px]"
  >
    <!-- <div class="font-roboto text-[18px] leading-6 text-[#949494]">
      {{ formattedDate }}
    </div> -->
    <div class="flex items-center gap-5">
      <div class="flex items-center gap-2">
        <div class="size-[12px] shrink-0 bg-article"></div>
        <NuxtLink
          :to="`/encyclopedia/${data.slug}`"
          class="font-roboto text-[18px] font-medium leading-[22px]"
          >{{ title }}</NuxtLink
        >
      </div>
      <div v-if="data.likes" class="flex items-center gap-1">
        <SvgIcon class="size-5" name="heart" />
        <span class="font-roboto text-[18px] leading-6 text-[#DBD8D8]">
          {{ data.likes }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  data?: Record<string, any>;
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { formatWikiTitle } = useTextCase();

const title = computed(() => formatWikiTitle(props.data));

// const formattedDate = computed(() => {
//   const date = props.data.created_at ?? props.data.published_at;
//   if (!date) return '';
//   return new Date(date).toLocaleDateString('ru-RU');
// });
</script>
